import HelpCircleIcon from '@/assets/icons/help-circle';
import LayerIcon from '@/assets/icons/layer';
import PIREPIcon from '@/assets/icons/map/PIREP';
import NotamIcon from '@/assets/icons/map/notam';
import TrafficIcon from '@/assets/icons/map/traffic';
import CheckIcon from '@/assets/icons/status-tracker/check';
import {useAppDispatch, useAppSelector} from '@/hooks/redux';
import {setLayer} from '@/redux/slice/mapSlice';
import {Popover} from 'antd';
import classNames from 'classnames';
import {useEffect} from 'react';

const ListToggle = () => {
  return (
    <div className="flex items-center gap-x-[8px]">
      <Popover
        content={<LayerContent />}
        overlayClassName="option-popover legend-popover"
        trigger={['click']}
      >
        <div
          className={classNames(
            'shadow-md cursor-pointer rounded-[8px] border-[0.5px] border-[#409EF24D] bg-[#409EF24D] p-[8px] hover:opacity-80'
          )}
        >
          <LayerIcon />
        </div>
      </Popover>

      <Popover
        content={<LegendContent />}
        overlayClassName="option-popover legend-popover"
        trigger={['click']}
      >
        <div
          className={classNames(
            'shadow-md cursor-pointer rounded-[8px] border-[0.5px] border-[#409EF24D] bg-[#409EF24D] p-[8px] hover:opacity-80',
            'rounded-full'
          )}
        >
          <HelpCircleIcon />
        </div>
      </Popover>
    </div>
  );
};

export default ListToggle;

export const LegendContent = () => {
  return (
    <div className="p-lg">
      <div className="text-[#F1F1F1] text-sm leading-sm font-[500] mb-[6px]">
        Legend
      </div>
      <div className="my-md flex items-center gap-x-md">
        <NotamIcon />
        <span className="text-[#F1F1F1] text-sm leading-sm">NOTAM</span>
      </div>
      <div className="my-md flex items-center gap-x-md">
        <PIREPIcon />
        <span className="text-[#F1F1F1] text-sm leading-sm">PIREP</span>
      </div>
      <div className="my-md flex items-center gap-x-md">
        <TrafficIcon color="#409ef2" />
        <span className="text-[#F1F1F1] text-sm leading-sm">SIA traffic</span>
      </div>
      <div className="my-md flex items-center gap-x-md">
        <TrafficIcon color="#E94860" />
        <span className="text-[#F1F1F1] text-sm leading-sm">
          Delayed traffic
        </span>
      </div>
      <div className="my-md flex items-center gap-x-md">
        <TrafficIcon color="#FF9500" />
        <span className="text-[#F1F1F1] text-sm leading-sm">{'<10,000ft'}</span>
      </div>
      <div className="my-md flex items-center gap-x-md">
        <TrafficIcon color="#FFD599" />
        <span className="text-[#F1F1F1] text-sm leading-sm">{'<20,000ft'}</span>
      </div>
      <div className="my-md flex items-center gap-x-md">
        <TrafficIcon color="#999999" />
        <span className="text-[#F1F1F1] text-sm leading-sm">Other traffic</span>
      </div>
    </div>
  );
};

export const LayerContent = () => {
  const dispatch = useAppDispatch();
  const layer = useAppSelector((state) => state.map.layer);

  useEffect(() => {
    window.updateData({
      event: 'toggleAirport',
      data: layer.airport ? 'visible' : 'none'
    });
  }, [layer.airport]);

  useEffect(() => {
    window.updateData({
      event: 'toggleNotam',
      data: layer.notam ? 'visible' : 'none'
    });
  }, [layer.notam]);

  useEffect(() => {
    window.updateData({
      event: 'togglePirep',
      data: layer.pirep ? 'visible' : 'none'
    });
  }, [layer.pirep]);

  useEffect(() => {
    window.updateData({
      event: 'toggleTraffic',
      data: layer.traffic ? 'visible' : 'none'
    });
  }, [layer.traffic]);

  useEffect(() => {
    window.updateData({
      event: 'toggleWeather',
      data: layer.weather ? 'visible' : 'none'
    });
  }, [layer.weather]);

  useEffect(() => {
    window.updateData({
      event: 'toggleFir',
      data: layer.fir ? 'visible' : 'none'
    });
  }, [layer.fir]);

  return (
    <div className="">
      {Object.keys(layer).map((key) => (
        <div
          className="flex items-center justify-between p-lg cursor-pointer hover:opacity-80 hover:bg-[#151515] transition-all duration-150 border-b border-[#3030304D]"
          key={key}
          onClick={() => {
            dispatch(
              setLayer({
                [key]: !layer[key as keyof typeof layer]
              })
            );
          }}
        >
          <span
            className={classNames(
              'text-sm leading-sm text-[#F1F1F1] capitalize',
              {
                '!uppercase': ['pirep', 'fir'].includes(key)
              }
            )}
          >
            {key}
          </span>
          {layer[key as keyof typeof layer] && <CheckIcon />}
        </div>
      ))}
    </div>
  );
};
